<template>
    <div class="collection-wrap" v-loading="loading">
        <h3>我的收藏</h3>

        <div class="collection-wrap_list">
            <div class="collection-wrap_item" v-for="(item,index) in list" :key="index" @click="$router.push(`/goodsDetail?id=${item.inventoryId}`)">
                <div class="collection-wrap_item_img">
                    <img :src="item.img" alt="" />
                    <div class="del-icon" @click.stop="qxCollectFun(item,index)"><i class="el-icon-delete"></i></div>
                </div>
                <p class="u-line-1 collection-wrap_item_title">{{item.title}}</p>
                <p class="u-flex u-row-center u-m-t-10">
                    <span class="collection-wrap_item_font1">￥{{item.price_sale}}</span>
                    <span class="collection-wrap_item_font2 u-m-l-24">库存：{{item.kucun}}</span>
                </p>
            </div>
        </div>
        <el-empty v-if="list.length == 0" description="暂无收藏"></el-empty>
        <div class="u-flex u-row-center u-m-t-40" v-if="count > 0">
             <el-pagination
                  background
                  layout="prev, pager, next,total,jumper"
                  @current-change="currentChangeFun"
                  :page-size="params.pagenum"
                  :total="count">
                </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            loading:true,
            count:0,
            params:{
                page:1,
                pagenum:16,
                shoucang:1
            },
            list:[]
        }
    },
    created(){
        this.getList()
    },
    methods:{
        getList(){
            this.$http.get('product_plist',this.params).then(res=>{
                this.loading = false
                if(res.code == 1){
                    this.list = res.data
                    this.count = res.count 
                }else{
                    this.$message.error(res.message)
                    this.list = []
                }
            })
        },
        //分页
        currentChangeFun(e){
            this.params.page = e
            this.getList()
        },
        //取消收藏
        qxCollectFun(item,index){
            this.$http.get('product_collect',{inventoryId:item.inventoryId,collect_type:1}).then(res=>{
                if(res.code == 1){
                    this.$message.success('取消收藏成功')
                    this.list.splice(index,1)
                }else{
                    this.$message.error(res.message)
                }
            })
        }
    }
};
</script>
<style lang="scss">
.collection-wrap {
    h3 {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 20px;
        color: #333333;
    }
    .collection-wrap_list {
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;
        .collection-wrap_item {
            width: 228px;
            cursor: pointer;
            margin-right: 25px;
            margin-bottom: 25px;
            .collection-wrap_item_img {
                width: 100%;
                height: 228px;
                position: relative;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
                .del-icon{
                    width: 50px;
                    height: 50px;
                    top: 0;
                    right: 0;
                    font-size: 26px;
                    position: absolute;
                    text-align: center;
                    line-height: 50px;
                    color: #fff;
                    display: none;
                }
            }
            .collection-wrap_item_title{
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 20px;
                color: #222222;
                margin-top: 15px;
            }
            .collection-wrap_item_font1{
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 20px;
                color: #CC0000;
            }
            .collection-wrap_item_font2{
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 20px;
                color: #A5A5A5;
            }
            &:hover{
                .collection-wrap_item_img{
                    box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.16);
                    .del-icon{
                      display: block;
                    }
                }
            }
        }
    }
}
</style>
